import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select";
import { StatusBadge } from "@/components/common";
import { STATUSES, STATUS_STYLES } from "@/lib/constants";
import { cn } from "@/lib/utils";

export const StatusSelect = ({ value, onChange, testId = "status-select", className, placeholder }) => (
  <Select value={value || undefined} onValueChange={onChange}>
    <SelectTrigger id={testId} data-testid={testId} className={cn("h-10 bg-white", className)}>
      {value ? <StatusBadge status={value} /> : <span className="text-slate-400">{placeholder || "Select status…"}</span>}
    </SelectTrigger>
    <SelectContent>
      {STATUSES.map((s) => (
        <SelectItem key={s} value={s} data-testid={`${testId}-option-${s}`} className={cn("font-medium", STATUS_STYLES[s].item)}>
          <span className="inline-flex items-center gap-2"><span className={cn("h-2.5 w-2.5 rounded-full", STATUS_STYLES[s].dot, s === "Completed" && "bg-teal-600")} />{s}</span>
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
